import { getContPoolManagementLists, addContPool, editContPool } from '../requests';

const initPagination = {
  pageSize: 10,
  currentPage: 1,
  total: 0,
};

const Model = {
  namespace: 'contPoolManagement',
  state: {
    tabledData: [],
    pagination: initPagination,
  },
  effects: {
    *getContPoolManagementLists({ payload }, { call, put }) {
      const res = yield call(getContPoolManagementLists, payload);
      if (res && res.code === 0) {
        yield put({
          type: 'saveContPoolManagementLists',
          payload: res.data,
        });
      }
    },
    *addContPool({ payload }, { call }) {
      return yield call(addContPool, payload);
    },
    *editContPool({ payload }, { call }) {
      return yield call(editContPool, payload);
    },
  },
  reducers: {
    saveContPoolManagementLists(state, { payload }) {
      const { pageNum, pageSize, total, dataInfos } = payload;
      const pagination = {
        currentPage: pageNum,
        pageSize,
        total,
      };
      return { ...state, tabledData: dataInfos, pagination };
    },
  },
};
export default Model;
